<template>
	<ListDetailLayout
			:store="companyRelationshipsStore"
			index-route-name="admin.companies.relationships"
			create-permissions="create:company-relationships"
			@on-create="$router.push({ name: 'admin.companies.relationships.relationship', params: { relationship: 'NEW' } })"
			@on-paginate="(page) => useOnPaginate(page, refreshRelationships, params)"
			@on-search="(page) => useOnSearch(page, refreshRelationships, params)"
	>
		<template #list>
			<li v-for="relationship in companyRelationshipsStore.getCompanyRelationships" :key="relationship.id">
				<router-link :to="{ name: 'admin.companies.relationships.relationship', params: { relationship: relationship.id } }" v-slot="{ isActive }">
					<div :class="[isActive ? 'border-primary-500 dark:bg-surface-600' : 'border-transparent hover:bg-surface-50 dark:hover:bg-surface-800', 'transition-colors border-l-4 flex items-center justify-between gap-x-6 py-5 pl-3 pr-4 bg-surface-0 dark:bg-surface-800']">

						<div class="min-w-0">
							<div class="flex items-start gap-x-3">
								<p class="text-sm font-semibold leading-6 text-surface-900 dark:text-surface-200">
									{{ relationship.primary_company?.name || $t('common.na') }}
									<span class="mx-2 text-surface-500">→</span>
									{{ relationship.secondary_company?.name || $t('common.na') }}
								</p>
							</div>
							<p class="mt-1 text-xs leading-5 text-surface-500 dark:text-surface-400">
								{{ relationship.relationship_type || $t('common.na') }}
							</p>
						</div>

					</div>
				</router-link>
			</li>
		</template>

		<template #detail>
			<router-view v-if="$route.params.relationship" @on-save="refreshRelationships" @on-delete="refreshRelationships"></router-view>
		</template>

	</ListDetailLayout>
</template>

<script>
import ListDetailLayout from "@/Layouts/ListDetailLayout.vue";
import Container from "@/Components/Container.vue";
import { mapStores } from "pinia";
import { useCompanyRelationshipsStore } from "@/stores/companyRelationships.js";
import { useOnPaginate, useOnSearch } from "@/Composables/Pagination.js";

export default {
	name: "CompanyRelationshipsIndex",
	components: { Container, ListDetailLayout },
	data() {
		return {
			params: {
				include: 'primaryCompany,secondaryCompany',
			},
		};
	},
	methods: {
		useOnSearch,
		useOnPaginate,
		refreshRelationships() {
			return this.companyRelationshipsStore.indexCompanyRelationships(this.params);
		},
	},
	computed: {
		...mapStores(useCompanyRelationshipsStore),
	},
	async mounted() {
		await this.refreshRelationships();
	},
};
</script>

<style scoped>
</style>
